import { IDocumento } from "../../ioip/sdk/base";

export interface IAnswerEntidadAdscrita {
  IdRadicadoEntrada: number;
  Observaciones: string;
  RespuestaDefinitiva: boolean;
  DocumentoPrincipal: string;
  Anexos: string[];
  Autor: string;
  NumeroDocumento: string;
  FechaEnvio?: Date;
  EstadoLineaHonor:string,
}

export function defaultAnswerEntidadAdscrita(): IAnswerEntidadAdscrita {
  return {
    Anexos: [],
    DocumentoPrincipal: '',
    IdRadicadoEntrada: 0,
    Observaciones: '',
    RespuestaDefinitiva: false,
    Autor: '',
    NumeroDocumento: '',
    FechaEnvio: null,
    EstadoLineaHonor: '',
  };
}